export default {
  authenticated: ({ user }) => (user === null ? false : !user.expired),

  accessToken: ({ user }) => (user === null ? null : user.access_token),

  tokenType: ({ user }) => (user === null ? null : user.token_type),

  expiresAt: ({ user }) => (user === null ? null : user.expires_at),

  role: ({ user }) => (user === null ? null : user.profile.role),

  profile({ user, permissions }) {
    if (user === null) {
      return null
    }
    const { name, sub } = user.profile
    return {
      id: sub,
      name,
      permissions
    }
  },

  mainCompany: ({ companies }) =>
    companies && companies.length ? companies.find((x) => x.main) : false,

  companies({ companies }) {
    return companies || []
  },

  hasPermissions: ({ permissions }) => (_permissions) =>
    permissions && permissions.length
      ? permissions.some((permission) => _permissions.includes(permission))
      : false,

  selectedMenuItem({ userMenu, menuItemId }) {
    const menuItem = userMenu?.find((x) => x.id == menuItemId)
    if (!menuItem) {
      return []
    }
    return menuItem.children.map((item) => ({
      description: item.description,
      detail: item.detail,
      hoverImage: item.mainImageHoverPath,
      icon: item.iconClasses,
      mainImage: item.mainImagePath,
      needSelectedStudent: item.needSelectedStudent,
      route: item.navigationPath,
      title: item.title,
      sortOrder: item.sortOrder,
    }))
  },

  getSiteMap: function(state) {
    return state.userMenu
  },
}
